import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import Loader from '../../components/ui/Loader/Loader';
import Ax from '../../components/hoc/Ax';
import Status from '../../components/ui/Status';
import DateService from '../../services/DateService';
import HttpAPICall from '../../services/HttpAPICall';
import { Link, useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import TicketDetail from '../transactions/ticketTransaction/TicketDetail';
import TicketTransactionAdd from '../transactions/ticketTransaction/TicketTransactionAdd';
import TicketsBoardManagement from '../transactions/ticketTransaction/TicketsBoardManagement';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../components/TapUi';
import TapIcon from '../../services/TapIcon';
import UpdateMultipleTicketModal from './UpdateMultipleTicketModal';
import { toast } from 'react-toastify';
import DownloadFile from "../../services/DownloadFile";
import swal from "sweetalert";
import { Modal } from 'bootstrap';
import TapSelect from '../../components/ui/TapSelect';
import InputEmployeeSearch from '../includes/ui/InputEmployeeSearch';
import InputWorkstationSearch from '../includes/ui/InputWorkstationSearch';
import InputAssetSearch from '../includes/ui/InputAssetSearch';
import InputSubAssemblySearch from '../includes/ui/InputSubAssemblySearch';
import CreatableSelect from "react-select/creatable";
import download from '../../services/DownloadFile';
import uuid from 'react-uuid';

const ProjectTicketData = forwardRef((props, ref) => {
    const { id } = useParams();
    const history = useHistory();
    const ticketListUrl                         = IAM_API_BASE_URL_2 + "/ticket/list";
    const ticketDetailUrl                       = IAM_API_BASE_URL_2 + "/ticket/detail";
    const ticketDownloadUrl                     = IAM_API_BASE_URL_2 + "/ticket/download";
    const ticketShareUrl                        = IAM_API_BASE_URL_2 + "/ticket/share";

    const access_token                          = useSelector(state => state.auth.access_token);
    const iamUserSite                           = useSelector(state => state.app.user_sites);
    const iamAssetTypes                         = useSelector(state => state.app.asset_type);
    const allAssetGroupsList                    = useSelector(state => state.app.asset_groups);
    const ticketDetailRef                       = React.createRef();
    
    const ticketSearchModalElem                 = useRef(null);
    const ticketSearchModal                     = useRef(null);
    const customLogsheetDownLoadElem            = useRef(null);
    const customLogsheetDownLoadModal           = useRef(null);
    const shareEmailElem                        = useRef(null);
    const shareEmailModal                       = useRef(null);
    
    const ticketSearchFormInitialState          =   {
            search_ticket_type_id               : "",
            search_ticket                       : "",
            search_ticket_id                    : null,
            search_ticket_header                : "",
            search_asset_id                     : null,
            search_site_ids                     : "",
            asset_group_ids                     : [],
            search_asset_type                   : "",
            search_tagged_users                 : [],
            search_ageing_days                  : "",
            closure_date_range                  : "",
            closure_date_range_start            : "",
            closure_date_range_end              : "",
            creation_date_range                 : "",
            creation_date_range_start           : "",
            creation_date_range_end             : "",
            due_date_range                      : "",
            due_date_range_start                : "",
            due_date_range_end                  : "",
            remark_ageing_days                  : "",
            search_ticket_status                : [],
            ticket_with_asset                   : "",
            search_tags                         : [],
            search_employees                    : [],
            search_workstation                  : "",
            search_sub_assembly                 : "",
            search_employee_id                  : "",
    };
    const ticketSearchFormLabel = {
        search_ticket_type_id                   : "Ticket Type : ",
        search_ticket                           : "Ticket : ",
        search_ticket_id                        : "Ticket ID : ",
        search_ticket_header                    : "Ticket Header : ",
        search_asset_id                         : "Asset : ",
        search_site_ids                         : "Site : ",
        asset_group_ids                         : "Asset Type Groups : ",
        search_asset_type                       : "Asset Type : ",
        search_tagged_users                     : "Tagged Users : ",
        search_ageing_days                      : "Ageing Days : ",
        closure_date_range                      : "Completion Date Range : ",
        creation_date_range                     : "Creation Date Range : ",
        due_date_range                          : "Due Date Range : ",
        remark_ageing_days                      : "Remark Ageing Days : ",
        search_ticket_status                    : "Ticket Status : ",
        ticket_with_asset                       : "Ticket With Asset : ",
        search_tags                             : "Tags : ",
        search_employees                        : "Linked Employees : ",
        search_workstation                      : "Workstation : ",
        search_sub_assembly                     : "Sub Assembly : ",
        search_employee_id                      : "Employee : ",
    };
    const initShareEmail = {
        to_emails                               : [],
        message                                 : "",
        subject                                 : "",
        attachment                              : "N",
    };
    const allTicketOptions = [
        { value: "my_ticket", label: "My Ticket (Created by me)" },
        { value: "my_tagged_tickets", label: " My Tagged Tickets" },
    ];

    const [ticketBoard, setTicketBoard]                 = useState(false)
    const [switchTicketBoard, setSwitchTicketBoard]     = useState("Switch to Ticket Board")
    const [modalId, setModalId]                         = useState(uuid());
    const [modalId2, setModalId2]                       = useState(uuid());
    const [modalId3, setModalId3]                       = useState(uuid());


    const [view_loading, setView_loading]               = useState(false)
    const [listing_tbl_page, setListing_tbl_page]       = useState(1)
    const [ticket_listing, setTicket_listing]           = useState([])
    const [listingMeta, setListingMeta]                 = useState(null)
    const [formSearchedElems, setFormSearchedElems]     = useState([])
    const [totalListingCount, setTotalListingCount]     = useState(0)
    const [searchedAsset, setSearchedAsset]             = useState(null)
    const [allSelected, setAllSelected]                 = useState(false)
    const [showProjectCard, setShowProjectCard]         = useState(true)
    const [assetId, setAssetId]                         = useState(null)
    const [form_loading, setForm_loading]               = useState(false)
    const [filterLoading, setFilterLoading]             = useState(false)
    const [saveFormSubmitting, setSaveFormSubmitting]   = useState(false)
    const [share_email_loading, setShare_email_loading] = useState(false)
    const [filterFormData, setFilterFormData]           = useState([])
    const [allTicketType, setAllTicketType]             = useState([])
    const [allTaggedUsers, setAllTaggedUsers]           = useState([])
    const [allStatusList, setAllStatusList]             = useState([])
    const [ticketTags, setTicketTags]                   = useState([])
    const [ticket_allow_tag, setTicket_allow_tag]       = useState([])
    const [ticket_allow_employees, setTicket_allow_employees] = useState([])
    const [iam_asset_types, setIam_asset_types]         = useState([])
    const [iam_user_sites, setIam_user_sites]           = useState([])
    const [shareEmailForm, setShareEmailForm]           = useState({ initShareEmail })
    const [allAssetTypesGroupsList, setAllAssetTypesGroupsList] = useState([])
    const [options, setOptions]                         = useState([])
    const [searchTicketOptions, setSearchTicketOptions] = useState([
        { value: "Y", label: "Yes" },
        { value: "N", label: "No" },
    ])
    const [customDownloadCriteria, setCustomDownloadCriteria] = useState([
        {
            key: "display_ticket_expense",
            label: "Ticket Expense",
            value: true,
            setting_key: "ticket_expense",
        },
        {
            key: "display_ticket_allocation",
            label: "Ticket Allocation",
            value: true,
            setting_key: "ticket_allocation",
        },
        {
            key: "display_ticket_consumption",
            label: "Ticket Consumption",
            value: true,
            setting_key: "ticket_consumption",
        },
    ])
    const [searchedSubAssembly, setSearchedSubAssembly]             = useState('')
    const [ticketEmployee, setTicketEmployee]                       = useState('')
    const [submittedTicketFilterForm, setSubmittedTicketFilterForm] = useState(ticketSearchFormInitialState)
    const [ticketSearchForm, setTicketSearchForm]                   = useState({ ...ticketSearchFormInitialState })
    const [searchedWorkstation, setSearchedWorkstation]             = useState('')
    const [searchedEmployees, setSearchedEmployees]                 = useState([])
    
    useImperativeHandle(ref, () => ({
        loadListingTblData,
        refreshData: () => refreshData(),
        ticketDownload,
        ticketSearchModalInit,
        shareModalInit,
        updateTicketModal,
        addDocumentModal,
        addRemarkModal,
        ticketExpenseHandler,
        shareTicketModalInit,
        customModalInit,
        initModalHandler: () => {
            openModalHandler() 
       }
    }));
   
    useEffect(() => {
        ticketSearchModalElem.current = document.getElementById(modalId);
        ticketSearchModal.current = new Modal(ticketSearchModalElem.current, { keyboard: false, backdrop: false });
        customLogsheetDownLoadElem.current = document.getElementById(modalId2);
        customLogsheetDownLoadModal.current = new Modal(customLogsheetDownLoadElem.current, { keyboard: false, backdrop: false });
        shareEmailElem.current = document.getElementById(modalId3);
        shareEmailModal.current = new Modal(shareEmailElem.current, { keyboard: false, backdrop: false });
        
        return () => {
            if (ticketSearchModal.current) {
                ticketSearchModal.current.dispose();
            }
            if (customLogsheetDownLoadModal.current) {
                customLogsheetDownLoadModal.current.dispose();
            }
            if (shareEmailModal.current) {
                shareEmailModal.current.dispose();
            }
            
        };
    }, []);

    useEffect(() => {
        filterFormDataInit()
        initalizeAppData();
    }, []);

    useEffect(() => {
        if (Object.keys(submittedTicketFilterForm).length > 0 || props.location?.search) {
            props.setListing_loading(true);
            loadListingTblData(1);
        }
    }, [submittedTicketFilterForm]);
    
   
    const openModalHandler = () => {
        if (ticketSearchModal) {
            ticketSearchModalOpen();
        }
        if (customLogsheetDownLoadModal) {
            customLogsheetDownLoadModalOpen();
        }
        if (shareEmailModal) {
            shareEmailModalOpen();
        }
        

    }
    const ticketSearchModalOpen = () => {
        if (ticketSearchModal.current) {
            ticketSearchModal.current.show();
        }
    }

    const ticketSearchModalClose = () => {
        if (ticketSearchModal.current) {
            ticketSearchModal.current.hide();
        }
    }

    const customLogsheetDownLoadModalOpen = () => {
        if (customLogsheetDownLoadModal.current) {
            customLogsheetDownLoadModal.current.show();
        }
    }

    const customLogsheetDownLoadModalClose = () => {
        if (customLogsheetDownLoadModal.current) {
            customLogsheetDownLoadModal.current.hide();
        }
    }
    const shareEmailModalOpen = () => {
        if (shareEmailModal.current) {
            shareEmailModal.current.show();
        }
    }

    const shareEmailModalClose = () => {
        if (shareEmailModal.current) {
            shareEmailModal.current.hide();
        }
    }
    
    const updateTicketModal = (id, addFormState = "detail") => {
        ticketDetailRef.current.updateTicketModalInit(id, addFormState);
    };

    const addDocumentModal = (id) => {
        ticketDetailRef.current.addDocumentModalInit(id);
    };

    const addRemarkModal = (id) => {
        ticketDetailRef.current.addRemarkInit(id);
    };

    const ticketExpenseHandler = (id) => {
        ticketDetailRef.current.ticketExpenseHandle();
    };
 
    const handleOnChangeCriteria = (event, index) => {
        const values = [...customDownloadCriteria];
        values[index].value = event.target.checked;
        setCustomDownloadCriteria(values)
    };

    const getShareEmailFormData = (id) => {
        setShare_email_loading(true)
        HttpAPICall.withAthorization(
            "GET",
            ticketShareUrl + "/form_data/" + id, access_token,
            {},
            {},
            (resp) => {
                let options = resp.data.users
                    .filter((s) => s.email !== "")
                    .map((s) => {
                        return { value: s.email, label: `${s.full_name} (${s.email})` };
                    });
                setOptions(options)
                setShareEmailForm({
                    ...shareEmailForm,
                    subject: `Ticket - ${props.ticket_view_data.activity_id} - ${props.ticket_view_data.header} Status Update`,
                },)

            }
        ).then(() => setShare_email_loading(false));
    };

    const shareTicketModalInit = () => {
        shareEmailModalOpen();
        getShareEmailFormData(props.ticket_view_data.activity_id);
    };

    const handleEmailChange = (selectedOption) => {
        setShareEmailForm({
            ...shareEmailForm,
            to_emails: selectedOption,
        })
    };

    const handleEmailCreate = (inputText) => {
        const newValue = { value: inputText.toLowerCase(), label: inputText };
        setOptions({ options: [...options, newValue] })
        let obj = {};
        obj["value"] = newValue.value;
        obj["label"] = newValue.label;
        shareEmailForm.to_emails.push(obj);
    };

    const submitcustomDownloadForm = (e) => {
        e.preventDefault();
        let downloadCriteria = customDownloadCriteria.filter(
            (download) => download.value == true
        );
        let selectedColumn = [];
        if (downloadCriteria && downloadCriteria.length > 0) {
            selectedColumn = downloadCriteria.map((dc) => {
                return { [dc.key]: dc.value == true ? "Y" : "N" };
            });
        }
        setSaveFormSubmitting(true)
        let params = {
            download: "download",
            ...selectedColumn.reduce((acc, obj) => ({ ...acc, ...obj }), {}),
        };
        HttpAPICall.withAthorization(
            "GET",
            ticketDownloadUrl + "/" + props.ticket_view_data.activity_id,
            access_token,
            { ...params },
            {},
            (response) => {
                download.file(response.data.file_path , response.data?.msg);
                customLogsheetDownLoadModalClose()
            }
        ).then(() => setSaveFormSubmitting(false)
        );
    };

    const resetDownloadCriteriaForm = () => {
        setCustomDownloadCriteria(customDownloadCriteria.map((v) => ({
            ...v,
            value: true,
        })))
    };

    const downloadTicketHandler = (activity_id) => {
        let ticketData = props.ticket_view_data;
        let setting = ticketData && ticketData.setting ? ticketData.setting : null;

        const updatedCustomDownloadCriteria = customDownloadCriteria.map(
            (v) => {
                const key = v.setting_key;
                const settingValue = setting && setting[key] ? setting[key] : null;
                if (settingValue == "N") {
                    return { ...v, value: false };
                } else {
                    return v; // Keep the existing value if not 'N'
                }
            }
        );
        setCustomDownloadCriteria(updatedCustomDownloadCriteria && updatedCustomDownloadCriteria.length > 0
            ? updatedCustomDownloadCriteria.filter((cd) => cd.value !== false)
            : [])

        const containsN = setting
            ? Object.values(setting).some((value) => value.includes("Y"))
            : false;

        if (containsN) {
            customLogsheetDownLoadModalOpen()
        } else {
            props.setTicketDownloading(true)

            HttpAPICall.withAthorization(
                "GET",
                ticketDownloadUrl + "/" + activity_id,
                access_token,
                {},
                {},
                (response) => {
                    download.file(response.data.file_path, response.data.msg);
                }
            ).then(() => props.setTicketDownloading(false)
            );
        }
    };

    const setFilterOnNavigation = () => {
        let ParamObject = new URLSearchParams(props.location.search);
        let searchedAsset = null;
        if (
            ParamObject.get("search_ticket_status") ||
            ParamObject.getAll("search_site_ids[]").length > 0 ||
            ParamObject.get("search_ticket") ||
            ParamObject.get("remark_ageing_days") ||
            ParamObject.get("search_asset_id")
        ) {
            let updateFilterForm = {};

            if (ParamObject.get("search_ticket_status")) {
                let selectedStatus = allStatusList
                    .filter((s) => ParamObject.get("search_ticket_status") == s.value)
                    .map((s) => s.value);
                if (selectedStatus) {
                    updateFilterForm["search_ticket_status"] = selectedStatus;
                }
            }
            if (ParamObject.getAll("search_site_ids[]").length > 0) {
                updateFilterForm["search_site_ids"] = new URLSearchParams(
                    props.location.search
                ).getAll("search_site_ids[]");
            }
            if (ParamObject.get("search_ticket")) {
                updateFilterForm["search_ticket"] = ParamObject.get("search_ticket");
            }
            if (ParamObject.get("remark_ageing_days")) {
                updateFilterForm["remark_ageing_days"] =
                    ParamObject.get("remark_ageing_days");
            }
            if (ParamObject.get("search_asset_id")) {
                updateFilterForm["search_asset_id"] =
                    ParamObject.get("search_asset_id");
                searchedAsset = {
                    value: ParamObject.get("search_asset_id"),
                    display_label: ParamObject.get("asset_name"),
                };
            }

            setTimeout(() => {
                setTicketSearchForm({
                    ...ticketSearchForm,
                    ...updateFilterForm,
                })
                setSearchedAsset(searchedAsset)
                submitTicketSearchForm();
            }, 1);
        } else if (ParamObject.get("ticket_id")) {
            loadListingTblData(1);
            viewTicket(ParamObject.get("ticket_id"));
        }
    }

    const initalizeAppData = () => {
        setIam_user_sites(iamUserSite.map((s) => ({ value: s.id, label: `${s.site_name} (${s.site_code})` })))
        setIam_asset_types(iamAssetTypes.map((at) => ({ value: at.id, label: at.asset_type_name })))
        setAllAssetTypesGroupsList(allAssetGroupsList.map((oc) => ({
            value: oc.id, label: oc.name, linked_asset_types: oc.asset_type_ids,
        })))
    };

    const ticketSearchModalInit = () => {
        ticketSearchModalOpen()
    };

    const customModalInit = () => {
        customLogsheetDownLoadModalOpen()
        setFilterLoading(true);
    };
   
    const shareModalInit = () => {
        shareEmailModalOpen()
        setFilterLoading(true);

    };
   
    const refreshData = () => {
        loadListingTblData(1, null, 'Y');
    };

    const handleOnCheckTicket = (e) => {
        const ticketId = e.target.value;
        let newCheckTicketids;

        if (e.target.checked) {
            newCheckTicketids = [...props.checkTicketids, ticketId];
        } else {
            newCheckTicketids = props.checkTicketids.filter(tid => tid !== ticketId);
        }
        props.setCheckTicketids(newCheckTicketids)
        setAllSelected(newCheckTicketids.length === ticket_listing.length)

    };

    const tapSelectChange = (selectedOption, formName, fieldName) => {
        setTicketSearchForm(prevState => ({
            ...prevState,
            [fieldName]: selectedOption ? selectedOption.value : null,
        }));
    };

    const formInputHandler = (e, formState, setFormState) => {
        const { name, value } = e.target;
        setFormState(prevState => ({
            ...prevState,
            [name]: value, 
        }));
    };
   
    const submitShareDocument = (e) => {
        e.preventDefault();
        setSaveFormSubmitting(true)
        let frmData = {
            activity_id: props.ticket_view_data.activity_id,
            to_emails: shareEmailForm.to_emails.map((s) => s.value),
            subject: shareEmailForm.subject,
            message: shareEmailForm.message,
            attachment: shareEmailForm.attachment,
        };
        
        HttpAPICall.withAthorization(
            "POST",
            ticketShareUrl, access_token,
            {},
            { ...frmData },
            (response) => {
                toast.success(response.data.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                shareEmailModalClose()
                setShareEmailForm({ ...initShareEmail })
            }
        ).then(() => setSaveFormSubmitting(false));
    };

    const handleSelectAllChange = (e) => {
        const isChecked = e.target.checked;
        const allEnabledTicketIds = ticket_listing.filter(item => item.status == 0).map(ticket => ticket.activity_id);
        setAllSelected(isChecked)
        props.setCheckTicketids(isChecked ? allEnabledTicketIds : [])
    };

    const loadListingTblData = (page = 1, ticket_id = null, recalculate_project_status = 'N') => {
        props.setListing_loading(ticket_id ? false : true,)
        setListing_tbl_page(page)
        let projectId = "";
        if (id) {
            projectId = id;
        }
        let params = {
            ...submittedTicketFilterForm,
            search_project_id: projectId,
            page: page,
            orderby: "project",
        };
        Object.keys(params).forEach(key => {
            if (params[key] === null || params[key] === undefined ||
                (Array.isArray(params[key]) && params[key].length === 0) ||
                params[key] === "") {
                delete params[key];
            }
        });
        HttpAPICall.withAthorization(
            "GET", ticketListUrl, access_token, params, {}, (resp) => {
                let respData = resp.data;
                let updatedListing = ticket_id
                    ? ticket_listing.map((item) =>
                        item.activity_id === ticket_id
                            ? respData.data.find(
                                (dataItem) => dataItem.activity_id === ticket_id
                            ) || item
                            : item
                    )
                    : respData.data;
                // setSubmittedTicketFilterForm({
                //     ...submittedTicketFilterForm,
                //     search_project_id: projectId,

                // })
                setTicket_listing(updatedListing)
                setListingMeta(respData.meta)
                setTotalListingCount(respData.meta.total)
            }
        ).then(() => props.setListing_loading(false));
    };

    const viewTicket = (id) => {
        props.setMinimizeTable(true)
        props.setCurrent_activity_id(id)
        setShowProjectCard(false)
        getTicketViewData(id);
    };
    const getTicketViewData = (id) => {
        setView_loading(true)
        HttpAPICall.withAthorization(
            "GET", ticketDetailUrl + "/" + id,
            access_token,
            {
                need_total_expense: "Y",
                need_ticket_allocation: "Y",
                need_ticket_consumption: "Y",
                need_ticket_demand:"Y",
                need_parent_ticket: "Y",
                need_child_tickets: "Y",
            },
            {},
            (resp) => {
                let respData = resp.data;
                props.setTicket_view_data(respData.data)
                props.setTicketHeader(respData.data.header)
                setAssetId(respData.data && respData.data.asset
                    ? respData.data.asset.asset_id
                    : null,)
            }
        ).then(() => setView_loading(false));
    };
    const ticketSearchClear = () => {
        setFormSearchedElems([]);
        setSearchedAsset(null);
        setTicketSearchForm({ ...ticketSearchFormInitialState });
        
        if (JSON.stringify(submittedTicketFilterForm) !== JSON.stringify(ticketSearchFormInitialState)) {
            setSubmittedTicketFilterForm({ ...ticketSearchFormInitialState });
        } else {
            loadListingTblData(1);
        }
        ticketSearchModalClose();
    };
   
    const openCreateTicketScreen = (type) => {
        setTicketBoard(false)
        props.toggleCreateTicket(type)
    };

    const submitTicketSearchForm = (e = null) => {
        e && e.preventDefault();
        let serachFormKeys = Object.keys(ticketSearchForm);

        let searchedElems = [];
        let searchParams = {};
        serachFormKeys.map((key) => {
            let label = ticketSearchFormLabel[key];
            let value = ticketSearchForm[key];
            if (value !== null && value !== undefined && value.toString().length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;
                    if (key == "search_asset_id") {
                        show_val = searchedAsset
                            ? searchedAsset.display_label
                            : "";
                    }
                    if (key == "search_sub_assembly") {
                        show_val = searchedSubAssembly
                            ? searchedSubAssembly.label
                            : "";
                    }
                    if (key == "search_employee_id") {
                        show_val = ticketEmployee
                            ? ticketEmployee.label
                            : "";
                    }
                    if (key == "search_workstation") {
                        show_val = searchedWorkstation
                            ? searchedWorkstation.label
                            : "";
                    }
                    if (key == "search_employees") {
                        show_val =
                            searchedEmployees &&
                                searchedEmployees.length > 0
                                ? searchedEmployees
                                    .map((emp, i) => emp.label)
                                    .join(", ")
                                : "";
                    }
                    if (key == "search_tags") {
                        show_val = ticketTags
                            .filter(
                                (s) =>
                                    ticketSearchForm.search_tags &&
                                    ticketSearchForm.search_tags.includes(s.value)
                            )
                            .map((s) => s.label)
                            .join(", ");
                    }
                    if (key == "search_site_ids") {
                        show_val = iam_user_sites
                            .filter((s) => value.includes(s.value))
                            .map((s) => s.label)
                            .join(", ");
                    }
                    if (key == "search_ticket_type_id") {
                        show_val = allTicketType
                            .filter((s) => value === s.value)
                            .map((s) => s.label)
                            .join(", ");
                    }
                    if (key == "search_ticket_header") {
                        show_val = ticketSearchForm
                            ? ticketSearchForm.search_ticket_header
                            : "";
                    }
                    if (key == "search_ticket_id") {
                        show_val = ticketSearchForm
                            ? ticketSearchForm.search_ticket_id
                            : "";
                    }
                    if (key == "asset_group_ids") {
                        show_val = allAssetTypesGroupsList
                            .filter((s) => value.includes(s.value))
                            .map((s) => s.label)
                            .join(", ");
                    }
                    if (key == "search_asset_type") {
                        show_val = iam_asset_types
                            .filter((s) => value.includes(s.value))
                            .map((s) => s.label)
                            .join(", ");
                    }
                    if (key == "search_ageing_days") {
                        show_val = ticketSearchForm
                            ? ticketSearchForm.search_ageing_days
                            : "";
                    }
                    if (key == "closure_date_range") {
                        show_val = filterFormData.periods
                            .filter((s) => value.includes(s.key))
                            .map((s) => s.display_with_date);
                    }
                    if (key == "creation_date_range") {
                        show_val = filterFormData.periods
                            .filter((s) => value.includes(s.key))
                            .map((s) => s.display_with_date);
                    }
                    if (key == "due_date_range") {
                        show_val = filterFormData.periods
                            .filter((s) => value.includes(s.key))
                            .map((s) => s.display_with_date);
                    }
                    if (key == "remark_ageing_days") {
                        show_val = ticketSearchForm
                            ? ticketSearchForm.remark_ageing_days
                            : "";
                    }
                    if (key == "search_tagged_users") {
                        show_val = allTaggedUsers
                            .filter((s) => value.includes(s.value))
                            .map((s) => s.label)
                            .join(", ");
                    }
                    if (key == "search_ticket") {
                        show_val = allTicketOptions
                            .filter((s) => value.includes(s.value))
                            .map((s) => s.label);
                    }
                    if (key == "search_ticket_status") {
                        show_val = allStatusList
                            .filter((s) => value.includes(s.value))
                            .map((s) => s.label)
                            .join(", ");
                    }
                    if (key == "ticket_with_asset") {
                        show_val = searchTicketOptions
                            .filter((s) => value.includes(s.value))
                            .map((s) => s.label)
                            .join(", ");
                    }

                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        setFormSearchedElems(searchedElems);
        ticketSearchModalClose();
        setSubmittedTicketFilterForm(searchParams);
    };

    const ticketDownload = () => {
        props.setReportDownloading(true);
        let params = {...submittedTicketFilterForm, search_project_id: id, orderby: "project", download: "download" };
        HttpAPICall.withAthorization("GET", ticketListUrl, access_token, params, {}, (res) => 
            DownloadFile.file(res.data.file_path, res.data.msg, res.data.navigation, props)
        ).then(() => props.setReportDownloading(false));
    };
    const filterFormDataInit = () => {
        setForm_loading(true)
        HttpAPICall.withAthorization(
            "GET",
            IAM_API_BASE_URL_2 + "/ticket/list_form_data", access_token, {}, {},
            (resp) => {
                setFilterFormData(resp.data)
                setAllTicketType(resp.data.ticket_types?.map((s) => {
                    return { value: s.id, label: s.name };
                }),)
                setAllTaggedUsers(resp.data.users?.map((s) => {
                    return { value: s.id, label: s.full_name };
                }),)

                setAllStatusList(resp.data.status_list?.map((s) => {
                    return { value: s.key, label: s.name };
                }),)

                setTicketTags(resp.data.tags && resp.data.tags.length > 0
                    ? resp.data.tags.map((tag) => {
                        return { value: tag.name, label: tag.name };
                    })
                    : [])

                setTicket_allow_tag(resp.data &&
                    resp.data.setting &&
                    resp.data.setting.ticket_allow_tag)
                setTicket_allow_employees(resp.data &&
                    resp.data.setting &&
                    resp.data.setting.ticket_allow_employees)

                // if (filterLoading === false) {
                //     setFilterOnNavigation();
                // }
            }
        ).then(() => {
            setForm_loading(false)
        });
    };
    const ticketSearchModalJsx = () => {
        return (
            <div className="modal fade" id={modalId}  ref={ticketSearchModalElem} tabIndex="-1">
                <div className="modal-dialog modal-xl ">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">
                                Ticket Search
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        {form_loading ? (
                            <Loader />
                        ) : (
                            <form
                                id="ticketSearchForm"
                                onSubmit={submitTicketSearchForm}
                            >
                                <div className="modal-body">
                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label col-form-label-sm ">
                                            Ticket
                                        </label>
                                        <div className="col-sm-4">
                                            <TapSelect
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder="All Tickets"
                                                containerHeight="30px"
                                                fontSize="93%"
                                                options={allTicketOptions}
                                                value={allTicketOptions.find(
                                                    (r) =>
                                                        r.value ===
                                                        ticketSearchForm.search_ticket
                                                )}
                                                changeEvent={(selectedOption) =>
                                                    tapSelectChange(
                                                        selectedOption,
                                                        "ticketSearchForm",
                                                        "search_ticket"
                                                    )
                                                }
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm ">
                                            Ticket Type
                                        </label>
                                        <div className="col-sm-4">
                                            <TapSelect
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder="Select Ticket Type"
                                                containerHeight="30px"
                                                fontSize="93%"
                                                options={allTicketType}
                                                value={allTicketType.find(
                                                    (r) =>
                                                        r.value ===
                                                        ticketSearchForm.search_ticket_type_id
                                                )}
                                                changeEvent={(selectedOption) =>
                                                    tapSelectChange(
                                                        selectedOption,
                                                        "ticketSearchForm",
                                                        "search_ticket_type_id"
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label col-form-label-sm">
                                            Ticket ID
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                name="search_ticket_id"
                                                className="form-control form-control-sm"
                                                placeholder="Ticket ID"
                                                autoComplete="off"
                                                value={ticketSearchForm.search_ticket_id}
                                                onChange={(e) => formInputHandler(e, ticketSearchForm, setTicketSearchForm)} 
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm ">
                                            Ticket Header
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                name="search_ticket_header"
                                                className="form-control form-control-sm"
                                                placeholder="Ticket Header"
                                                autoComplete="off"
                                                value={ticketSearchForm.search_ticket_header}
                                                onChange={(e) => formInputHandler(e, ticketSearchForm, setTicketSearchForm)} 
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label col-form-label-sm">
                                            Ticket Status
                                        </label>
                                        <div className="col-sm-4">
                                            <TapSelect
                                                options={allStatusList}
                                                changeEvent={(selectedOption) => {
                                                    const selectedValues = selectedOption ? selectedOption.map(opt => opt.value) : [];
                                                    setTicketSearchForm(prevState => ({
                                                        ...prevState,
                                                        search_ticket_status: selectedValues,
                                                    }));
                                                }}

                                                isSearchable={true}
                                                isClearable={true}
                                                isMulti={true}
                                                value={allStatusList.filter((s) =>
                                                    ticketSearchForm.search_ticket_status && Array.isArray(ticketSearchForm.search_ticket_status) &&
                                                    ticketSearchForm.search_ticket_status.includes(
                                                        s.value
                                                    )
                                                )}
                                                placeholder="Select Ticket Status"
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm ">
                                            Asset
                                        </label>
                                        <div className="col-sm-4">
                                            <InputAssetSearch
                                                placeholder="Search Asset"
                                                changeEvent={(selectedOption) => {
                                                    tapSelectChange(
                                                        selectedOption,
                                                        "ticketSearchForm",
                                                        "search_asset_id"
                                                    );
                                                    setSearchedAsset(selectedOption
                                                        ? selectedOption
                                                        : null,)
                                                }}
                                                value={
                                                    searchedAsset
                                                        ? {
                                                            ...searchedAsset,
                                                            label: searchedAsset.display_label,
                                                        }
                                                        : null
                                                }
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label col-form-label-sm ">
                                            Site Name
                                        </label>
                                        <div className="col-sm-4">
                                            <TapSelect
                                                options={iam_user_sites}
                                                changeEvent={(selectedOption) => {
                                                    const selectedValues = selectedOption ? selectedOption.map(opt => opt.value) : [];
                                                    setTicketSearchForm(prevState => ({
                                                        ...prevState,
                                                        search_site_ids: selectedValues,
                                                    }));
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                isMulti={true}
                                                value={iam_user_sites.filter((s) => Array.isArray(ticketSearchForm.search_site_ids) &&
                                                    ticketSearchForm.search_site_ids.includes(
                                                        s.value
                                                    )
                                                )}
                                                placeholder="Select Site"
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm ">
                                            Ticket With Asset
                                        </label>
                                        <div className="col-sm-4">
                                            <TapSelect
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder="Ticket With Asset"
                                                containerHeight="30px"
                                                fontSize="93%"
                                                options={searchTicketOptions}
                                                value={searchTicketOptions.find(
                                                    (r) =>
                                                        r.value ===
                                                        ticketSearchForm.ticket_with_asset
                                                )}
                                                changeEvent={(selectedOption) =>
                                                    tapSelectChange(
                                                        selectedOption,
                                                        "ticketSearchForm",
                                                        "ticket_with_asset"
                                                    )
                                                }
                                            />
                                        </div>

                                        <label className="col-sm-2 col-form-label col-form-label-sm mt-3">
                                            Ticket Employee
                                        </label>
                                        <div className="col-sm-4 mt-3">
                                            <InputEmployeeSearch
                                                placeholder="Search Employee"
                                                changeEvent={(selectedOption) => {
                                                    setTicketEmployee(selectedOption
                                                        ? selectedOption
                                                        : "")
                                                    tapSelectChange(
                                                        selectedOption,
                                                        "ticketSearchForm",
                                                        "search_employee_id"
                                                    );
                                                }}
                                                menuPlacement="top"
                                                value={
                                                    ticketEmployee && ticketEmployee
                                                }
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm mt-3">
                                            Workstation
                                        </label>
                                        <div className="col-sm-4 mt-3">
                                            <InputWorkstationSearch
                                                placeholder="Search Workstation"
                                                changeEvent={(selectedOption) => {
                                                    setSearchedWorkstation(selectedOption
                                                        ? selectedOption
                                                        : "")
                                                    tapSelectChange(
                                                        selectedOption,
                                                        "ticketSearchForm",
                                                        "search_workstation"
                                                    );
                                                }}
                                                menuPlacement="top"
                                                isMulti={false}
                                                value={
                                                    searchedWorkstation &&
                                                    searchedWorkstation
                                                }
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm mt-3">
                                            Sub Assembly
                                        </label>
                                        <div className="col-sm-4 mt-3">
                                            <InputSubAssemblySearch
                                                placeholder="Search Sub Assembly"
                                                changeEvent={(selectedOption) => {
                                                    setSearchedSubAssembly(selectedOption
                                                        ? selectedOption
                                                        : "",)
                                                    tapSelectChange(
                                                        selectedOption,
                                                        "ticketSearchForm",
                                                        "search_sub_assembly"
                                                    );
                                                }}
                                                menuPlacement="top"
                                                isMulti={false}
                                                value={
                                                    searchedSubAssembly &&
                                                    searchedSubAssembly
                                                }
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm mt-3">
                                            Asset Type Group
                                        </label>
                                        <div className="col-sm-4 mt-3">
                                            <TapSelect
                                                options={allAssetTypesGroupsList}
                                                changeEvent={(selectedOption) => {
                                                    setTicketSearchForm({
                                                        ...ticketSearchForm,
                                                        asset_group_ids:
                                                            selectedOption && selectedOption.length > 0
                                                                ? selectedOption.map((o) => o.value)
                                                                : [],
                                                        search_asset_type:
                                                            selectedOption && selectedOption.length > 0
                                                                ? selectedOption
                                                                    .map((s) => s.linked_asset_types)
                                                                    .flat()
                                                                : [],
                                                    })
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                isMulti={true}
                                                value={allAssetTypesGroupsList.filter((s) =>

                                                    Array.isArray(ticketSearchForm.asset_group_ids) &&
                                                    ticketSearchForm.asset_group_ids.includes(
                                                        s.value
                                                    )
                                                )}
                                                placeholder="Select Asset Type Group"
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm  mt-3">
                                            Asset Type
                                        </label>
                                        <div className="col-sm-4 mt-3">
                                            <TapSelect
                                                options={iam_asset_types}
                                                changeEvent={(selectedOption) => {
                                                    const selectedValues = selectedOption ? selectedOption.map(opt => opt.value) : [];
                                                    setTicketSearchForm(prevState => ({
                                                        ...prevState,
                                                        search_asset_type: selectedValues,
                                                    }));
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                isMulti={true}
                                                value={iam_asset_types.filter((s) =>

                                                    Array.isArray(ticketSearchForm.search_asset_type) &&
                                                    ticketSearchForm.search_asset_type.includes(
                                                        s.value
                                                    )
                                                )}
                                                placeholder="Select Asset Type"
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm mt-3">
                                            Tagged User
                                        </label>
                                        <div className="col-sm-4 mt-3">
                                            <TapSelect
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder="Select User"
                                                containerHeight="30px"
                                                fontSize="93%"
                                                isMulti={true}
                                                options={allTaggedUsers}
                                                value={allTaggedUsers.filter((s) =>
                                                    ticketSearchForm.search_tagged_users && Array.isArray(ticketSearchForm.search_tagged_users) &&
                                                    ticketSearchForm.search_tagged_users.includes(s.value)
                                                )}
                                                changeEvent={(selectedOption) => {
                                                    const selectedValues = selectedOption ? selectedOption.map(opt => opt.value) : [];
                                                    setTicketSearchForm(prevState => ({
                                                        ...prevState,
                                                        search_tagged_users: selectedValues,
                                                    }));
                                                }}
                                            />

                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm mt-3">
                                            Ticket Ageing
                                        </label>
                                        <div className="col-sm-4 mt-3">
                                            <input
                                                type="text"
                                                name="search_ageing_days"
                                                className="form-control form-control-sm"
                                                placeholder="Example. 0-5 for a range or 4 for Ticket Aging"
                                                autoComplete="off"
                                                value={ticketSearchForm.search_ageing_days}
                                                onChange={(e) => formInputHandler(e, ticketSearchForm, setTicketSearchForm)} 
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm mt-3">
                                            Creation Date
                                        </label>
                                        <div className="col-sm-4 mt-3">
                                            <PeriodSelectionWithCustom
                                                periods={
                                                    filterFormData &&
                                                        filterFormData.periods !== undefined
                                                        ? filterFormData.periods
                                                        : []
                                                }
                                                required={false}
                                                value={ticketSearchForm.creation_date_range}
                                                startDate={
                                                    ticketSearchForm.creation_date_range_start
                                                }
                                                endDate={
                                                    ticketSearchForm.creation_date_range_end
                                                }
                                                onSelectPeriod={(period, startDate, endDate) => {
                                                    setTicketSearchForm({
                                                        ...ticketSearchForm,
                                                        creation_date_range: period,
                                                        creation_date_range_start: startDate,
                                                        creation_date_range_end: endDate,
                                                    })
                                                }}
                                                className="form-control-sm"
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm mt-3">
                                            Completion Date
                                        </label>
                                        <div className="col-sm-4 mt-3">
                                            <PeriodSelectionWithCustom
                                                periods={
                                                    filterFormData &&
                                                        filterFormData.periods !== undefined
                                                        ? filterFormData.periods
                                                        : []
                                                }
                                                required={false}
                                                value={ticketSearchForm.closure_date_range}
                                                startDate={
                                                    ticketSearchForm.closure_date_range_start
                                                }
                                                endDate={
                                                    ticketSearchForm.closure_date_range_end
                                                }
                                                onSelectPeriod={(period, startDate, endDate) => {
                                                    setTicketSearchForm({
                                                        ...ticketSearchForm,
                                                        closure_date_range: period,
                                                        closure_date_range_start: startDate,
                                                        closure_date_range_end: endDate,
                                                    })
                                                }}
                                                className="form-control-sm"
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm   mt-3">
                                            Due Date
                                        </label>
                                        <div className="col-sm-4 mt-3">
                                            <PeriodSelectionWithCustom
                                                periods={
                                                    filterFormData &&
                                                        filterFormData.periods !== undefined
                                                        ? filterFormData.periods
                                                        : []
                                                }
                                                required={false}
                                                value={ticketSearchForm.due_date_range}
                                                startDate={
                                                    ticketSearchForm.due_date_range_start
                                                }
                                                endDate={ticketSearchForm.due_date_range_end}
                                                onSelectPeriod={(period, startDate, endDate) => {
                                                    setTicketSearchForm({
                                                        ...ticketSearchForm,
                                                        due_date_range: period,
                                                        due_date_range_start: startDate,
                                                        due_date_range_end: endDate,
                                                    })
                                                }}
                                                className="form-control-sm"
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm mt-3">
                                            Remark Ageing
                                        </label>
                                        <div className="col-sm-4 mt-3">
                                            <input
                                                type="text"
                                                name="remark_ageing_days"
                                                className="form-control form-control-sm"
                                                placeholder="Example. 0-5 for a range or 4 for Remark Aging"
                                                autoComplete="off"
                                                value={ticketSearchForm.remark_ageing_days}
                                                onChange={(e) => formInputHandler(e, ticketSearchForm, setTicketSearchForm)} 
                                            />
                                        </div>
                                        {ticket_allow_tag == "Y" && (
                                            <Ax>
                                                <label className="col-sm-2 col-form-label col-form-label-sm mt-3">
                                                    Tags
                                                </label>
                                                <div className="col-sm-4 mt-3 mt-3">
                                                    <TapSelect
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        placeholder="Select Tags"
                                                        containerHeight="30px"
                                                        fontSize="93%"
                                                        isMulti={true}
                                                        options={ticketTags}



                                                        value={ticketTags.filter(
                                                            (s) =>
                                                                ticketSearchForm.search_tags && Array.isArray(ticketSearchForm.search_tags) &&
                                                                ticketSearchForm.search_tags.includes(
                                                                    s.value
                                                                )
                                                        )}
                                                        changeEvent={(selectedOption) => {
                                                            const selectedValues = selectedOption ? selectedOption.map(opt => opt.value) : [];
                                                            setTicketSearchForm(prevState => ({
                                                                ...prevState,
                                                                search_tags: selectedValues,
                                                            }));
                                                        }}
                                                    />
                                                </div>
                                            </Ax>
                                        )}
                                        {ticket_allow_employees == "Y" && (
                                            <Ax>
                                                <label className="col-sm-2 col-form-label col-form-label-sm mt-3">
                                                    Linked Employees
                                                </label>
                                                <div className="col-sm-4 mt-3">
                                                    <InputEmployeeSearch
                                                        placeholder="Search Employees"
                                                        changeEvent={(selectedOption) => {
                                                            setSearchedEmployees(selectedOption && selectedOption.length > 0
                                                                ? selectedOption
                                                                : [])
                                                            tapSelectChange(
                                                                selectedOption,
                                                                "ticketSearchForm",
                                                                "search_employees"
                                                            );
                                                        }}
                                                        menuPlacement="top"
                                                        isMulti={true}
                                                        value={
                                                            searchedEmployees &&
                                                                searchedEmployees.length > 0
                                                                ? searchedEmployees.map((a) => {
                                                                    a.label = a.label;
                                                                    return a;
                                                                })
                                                                : []
                                                        }
                                                        containerHeight="30px"
                                                        fontSize="93%"
                                                    />
                                                </div>
                                            </Ax>
                                        )}
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                        onClick={ticketSearchClear}
                                    >
                                        Clear
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        Search
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        );
    };
    const shareTicketModalJsx = () => {
        return (
            <div className="modal fade"   id={modalId3}  ref={shareEmailElem} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addAssetModalLabel">
                                Share Ticket{" "}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        {share_email_loading ? (
                            <Loader />
                        ) : (
                            <form id="addModalForm" onSubmit={submitShareDocument}>
                                <div className="modal-body">
                                    <div className="row align-items-center">
                                        <div className="col-md-4">
                                            <label className="form-label require">To (Email)</label>
                                        </div>
                                        <div className="col-md-8">
                                            <CreatableSelect
                                                isMulti
                                                required={true}
                                                value={shareEmailForm.to_emails}
                                                options={options}
                                                onChange={(selectedItem) =>
                                                    handleEmailChange(selectedItem)
                                                }
                                                onCreateOption={(inputText, callback) =>
                                                    handleEmailCreate(inputText, callback)
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row align-items-center mt-3">
                                        <div className="col-md-4">
                                            <label className="form-label require">Subject</label>
                                        </div>
                                        <div className="col-md-8">
                                            <input
                                                name="subject"
                                                type="text"
                                                value={shareEmailForm.subject}
                                                className="form-control text-capitalize"
                                                autoComplete="off"
                                                required={true}
                                                onChange={(e) => formInputHandler(e, shareEmailForm, setShareEmailForm)} 
                                               
                                                placeholder="Enter Subject"
                                            />
                                        </div>
                                    </div>
                                    <div className="row  mt-3">
                                        <div className="col-md-4">
                                            <label className="form-label require">Message</label>
                                        </div>
                                            <div className="col-md-8">
                                                <textarea
                                                    name="message" 
                                                    placeholder="Enter Message"
                                                    className="form-control"
                                                    value={shareEmailForm.message} 
                                                    autoComplete="off"
                                                    required={true}
                                                    onChange={(e) => formInputHandler(e, shareEmailForm, setShareEmailForm)} 
                                                    style={{ height: "100px" }}
                                                />
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer d-flex justify-content-between">
                                    <div className="mt-0">
                                        <input
                                            name="attachment"
                                            type="checkbox"
                                            value="N"
                                            onChange={(e) => {
                                                formInputHandler(e, shareEmailForm, setShareEmailForm)
                                                setShareEmailForm({
                                                    ...shareEmailForm,
                                                    attachment:
                                                        shareEmailForm.attachment == "Y"
                                                            ? "N"
                                                            : "Y",
                                                })
                                            }}
                                            className="form-check-input "
                                        />
                                        <label className="form-check-label mx-2">
                                            Attach Documents of the Ticket with Email
                                        </label>
                                    </div>
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-secondary mx-2"
                                            disabled={saveFormSubmitting ? true : false}
                                            data-bs-dismiss="modal"
                                            onClick={() => {
                                                setShareEmailForm({ ...initShareEmail })

                                            }}
                                        >
                                            Close
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={saveFormSubmitting ? true : false}
                                        >
                                            Submit{" "}
                                            {saveFormSubmitting ? (
                                                <TapIcon.FontAwesomeIcon
                                                    icon={TapIcon.faSyncAlt}
                                                    className="fa-spin"
                                                />
                                            ) : (
                                                ""
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        );
    };
    const customDownloadFormJsx = () => {
        return (
            <div
                className="modal fade right"
                id={modalId2}  ref={customLogsheetDownLoadElem}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">
                                Select Columns for Excel Download
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form
                                onSubmit={submitcustomDownloadForm}
                                id="addCustomDownloadForm"
                            >
                                <div className="tab_content_wrapper my-2">
                                    <span className="content_heading">Select Columns </span>
                                </div>
                                <div className="row my-3">
                                    {customDownloadCriteria &&
                                        customDownloadCriteria.length > 0 &&
                                        customDownloadCriteria.map((criteria, index) => {
                                            return (
                                                <Ax>
                                                    <div className="col-sm-1" key={index + 1}>
                                                        <input
                                                            name={criteria.key}
                                                            type="checkbox"
                                                            value={criteria.value}
                                                            checked={criteria.value == true ? true : false}
                                                            className="form-check-input"
                                                            id={criteria.key}
                                                            onChange={(e) =>
                                                                handleOnChangeCriteria(e, index)
                                                            }
                                                        />
                                                    </div>
                                                    <label
                                                        className="col-sm-5 col-form-label col-form-label-sm"
                                                        htmlFor={criteria.key}
                                                    >
                                                        {criteria.label}
                                                    </label>
                                                </Ax>
                                            );
                                        })}
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                                disabled={saveFormSubmitting}
                                onClick={resetDownloadCriteriaForm}
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={saveFormSubmitting}
                                form="addCustomDownloadForm"
                            >
                                Submit{" "}
                                {saveFormSubmitting ? (
                                    <TapIcon.FontAwesomeIcon
                                        icon={TapIcon.faSyncAlt}
                                        className="fa-spin"
                                    />
                                ) : (
                                    ""
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const ticketTransactionTableListJsx = () => {
        return (
            <Ax>
                <DisplaySearchCriteria searchedElems={formSearchedElems} onClearFilter={ticketSearchClear} />
                <table className="table table-bordered bg-white table-hover table-fixed table-sm" >
                    <thead className="table-secondary">
                        {props.minimizeTable ? (
                            <tr>
                                <th scope="col" style={{ width: "20%" }}>Ticket{" "}</th>
                            </tr>
                        ) : (
                            <Ax>
                                <tr className="text-center">
                                    <th>
                                        <input
                                            type="checkbox"
                                            checked={allSelected}
                                            onChange={handleSelectAllChange}
                                        />
                                    </th>
                                    <th style={{ width: "5%" }}> S.No </th>
                                    <th style={{ width: "10%" }}>Ticket ID</th>
                                    <th style={{ width: "12%" }}>Ticket Type</th>
                                    <th style={{ width: "24%" }}>Header</th>
                                    <th style={{ width: "10%" }}>Ticket For</th>
                                    <th style={{ width: "8%" }}>Starting date</th>
                                    <th style={{ width: "4%" }}>Estimated Days</th>
                                    <th style={{ width: "4%" }}>Actual Days</th>
                                    <th style={{ width: "4%" }}>Critical Path</th>
                                    <th style={{ width: "10%" }}>Last Updated</th>
                                    <th style={{ width: "8%" }}>Status</th>
                                    <th style={{ width: "5%" }}> Action</th>
                                </tr>
                            </Ax>
                        )}
                    </thead>
                    <tbody>
                        {props.listing_loading ? (
                            <tr><td colSpan="13"><Loader /></td></tr>
                        ) : ticket_listing.length > 0 ? (
                            ticket_listing.map((item, index) => {
                                let ticketFor =
                                    item.ticket_for === "sub_assembly"
                                        ? item.subAssembly && item.subAssembly.name
                                        : item.ticket_for === "employee"
                                            ? item.employee && item.employee.name
                                            : item.ticket_for === "workstation"
                                                ? item.workStation && item.workStation.name
                                                : item.ticket_for === "site"
                                                    ? item.site && item.site.site_name
                                                    : item.ticket_for === "asset"
                                                        ? item.asset && item.asset.name
                                                        : "";
                                return (
                                    <tr key={index}>
                                        {props.minimizeTable ? (
                                            <Ax>
                                                <td style={{ width: "25%" }}>
                                                    <div className="text-capitalize">
                                                        <Link onClick={() => viewTicket(item.activity_id)} className="link-primary"  > {item?.header} </Link>
                                                        <small className="float-end">{item.activity_id}</small>
                                                    </div>
                                                    <div className="mt-1 text-sm">
                                                        {item?.ticket_type?.name}
                                                        <span className="float-end"><Status color={item.status_color_code}>{item.status_text}</Status></span>
                                                    </div>
                                                </td>
                                            </Ax>
                                        ) : (
                                            <Ax>
                                                <td>
                                                    <input
                                                        name="ss"
                                                        disabled={item.status != 0}
                                                        type="checkbox"
                                                        value={item.activity_id}
                                                        checked={[...props.checkTicketids].find(tid => tid === item.activity_id)}
                                                        className="form-check-input"
                                                        onChange={(e) => handleOnCheckTicket(e)}
                                                    />
                                                </td>
                                                <td className="text-center">{item.sr_num}</td>
                                                <td className="text-center">
                                                    <Link className="link-primary text-capitalize" onClick={() => viewTicket(item.activity_id)} >{item.activity_id ? item.activity_id : "-"} </Link>
                                                </td>
                                                <td>{item.ticket_type ? item.ticket_type.name : "-"}</td>
                                                <td>{item.header}</td>
                                                <td className="text-capitalize">
                                                    {item.ticket_for_name && (
                                                        <span>
                                                            <small>{item.ticket_for_name}</small>:<br />
                                                            {ticketFor}
                                                        </span>
                                                    )}
                                                </td>
                                                <td >{item.start_date_display}</td>
                                                <td className="text-end">{item.estimate_days}</td>
                                                <td className="text-end">{item.actual_days}</td>
                                                <td className="text-center">{item.is_in_critical_path == 'Y' ? "Yes" : ""}</td>
                                                <td>
                                                    {item.last_updated_on_display ?? "-"} <br />
                                                    {item.latest_remark ? (
                                                        <small>{item.latest_remark?.remarks}</small>
                                                    ) : null}
                                                </td>
                                                <td className="text-center">
                                                    <Status color={item.status_color_code}>{item.status_text}</Status>
                                                </td>
                                                <td className="text-center">
                                                    <TapIcon.imageIcon
                                                        icon={TapIcon.ListActionIcon}
                                                        alt="action-icon"
                                                        className="img-fluid px-3"
                                                        data-bs-toggle="dropdown"
                                                        href="#"
                                                        role="button"
                                                        aria-expanded="false"
                                                    />
                                                    <ul
                                                        className="dropdown-menu"
                                                        aria-labelledby="dropdownMenuButton1"
                                                    >
                                                        <li>
                                                            <Link
                                                                className="dropdown-item"
                                                                role="button"
                                                                onClick={() =>
                                                                    viewTicket(item.activity_id)
                                                                }
                                                            >
                                                                View
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link
                                                                className="dropdown-item"
                                                                role="button"
                                                                onClick={() =>
                                                                    downloadTicketHandler(item.activity_id)
                                                                }
                                                            >
                                                                Download
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </Ax>
                                        )}
                                    </tr>
                                );
                            })
                        ) : (
                            <tr><td colSpan="13" className="text-center">No Records</td></tr>
                        )}
                    </tbody>
                </table>
                <DisplayListPagination meta={listingMeta} onPageChange={(e) => loadListingTblData(e.selected + 1)} />
            </Ax>
        );
    };

    return <>
        <div className="row mb-2"
        >
            {props.ticketListAddBoard === "ticketAdd" && <TicketTransactionAdd
                createFromProject={true}
                openCreateTicketScreen={openCreateTicketScreen}
                projectDetails={props.projectDetails}
                ticketList={() => loadListingTblData(1)}
                projectDetail={props.projectDetails}
            />}
            {props.ticketListAddBoard === "ticketsBoard" && <TicketsBoardManagement 
                createFromProject={true}
                projectId={props.projectDetails?.id}
            />}
            {props.ticketListAddBoard === "ticketListShow" && <Ax>
                <div className={[props.minimizeTable ? "col-sm-3 " : "col-sm-12"].join(" ")}>
                    <div style={{ overflowX: "hidden",overflowY: "auto", height: "calc(100vh - 160px)", padding: "0px", backgroundColor: "white"}}>{ticketTransactionTableListJsx()}</div>

                </div>
                {props.minimizeTable && <div className="col-sm-9 bg-app px-1" style={{ overflowY: "auto", height: "calc(100vh - 160px)", padding: "0px", backgroundColor: "white" }}>
                    {view_loading ? <Loader /> : <TicketDetail
                        ticketData={props.ticket_view_data}
                        showOtherDetail="Y"
                        performAction="Y"
                        afterUpdate={(ticket_id) => {
                            loadListingTblData(
                                listing_tbl_page,
                                ticket_id
                            );
                        }}
                        listingUpdateWithProject={loadListingTblData}
                        ref={ticketDetailRef}
                        projectDetails={props.projectDetails}
                    />}
                </div>}
            </Ax>}
            {ticketSearchModalJsx()}
            {shareTicketModalJsx()}
            {customDownloadFormJsx()}
        </div>

    </>
});


export default ProjectTicketData;